export const infoType = [
  {
    fieldPath: 'EmergencyAlertType__c',
    label: 'レベル5 特別警報・特別警報',
    levelNumber: 5,
    levelName: '特別警報',
    color: '#0C000C',
    dark: true,
    showLegend: true,
    order: 1,
    levelTypes: ['大雨', '土砂災害', '氾濫', '高潮'],
    traditionalTypes: ['暴風', '暴風雪', '大雪', '波浪'],
  },
  {
    fieldPath: 'DangerAlertType__c',
    label: 'レベル4 危険警報',
    levelNumber: 4,
    levelName: '危険警報',
    color: '#AA00AA',
    dark: true,
    showLegend: true,
    order: 2,
    levelTypes: ['大雨', '土砂災害', '氾濫', '高潮'],
    traditionalTypes: [],
  },
  {
    fieldPath: 'WarningAlertType__c',
    label: 'レベル3 警報・警報',
    levelNumber: 3,
    levelName: '警報',
    color: '#FF2800',
    dark: true,
    showLegend: true,
    order: 3,
    levelTypes: ['大雨', '土砂災害', '氾濫', '高潮'],
    traditionalTypes: ['暴風', '暴風雪', '大雪', '波浪'],
  },
  {
    fieldPath: 'AdvisoryAlertType__c',
    label: 'レベル2 注意報・注意報',
    levelNumber: 2,
    levelName: '注意報',
    color: '#F2E700',
    dark: false,
    showLegend: true,
    order: 4,
    levelTypes: ['大雨', '土砂災害', '氾濫', '高潮'],
    traditionalTypes: ['強風', '風雪', '大雪', '波浪', '濃霧', '雷', '乾燥', 'なだれ', '着氷', '着雪', '霜', '低温', '融雪'],
  },
  {
    fieldPath: 'TsunamiAlert__c',
    label: '津波',
    color: '#C800FF',
    dark: true,
    showLegend: false,
    order: 5,
    colorMap: {
      '大津波警報': { color: '#C800FF', dark: true },
      '津波警報': { color: '#FF2800', dark: true },
      '津波注意報': { color: '#FAF500', dark: false },
    },
  },
  {
    fieldPath: 'TsunamiAlert__c_legend_1',
    label: '大津波警報',
    color: '#C800FF',
    dark: true,
    showLegend: true,
    legendOnly: true,
    order: 5.1,
  },
  {
    fieldPath: 'TsunamiAlert__c_legend_2',
    label: '津波警報',
    color: '#FF2800',
    dark: true,
    showLegend: true,
    legendOnly: true,
    order: 5.2,
  },
  {
    fieldPath: 'TsunamiAlert__c_legend_3',
    label: '津波注意報',
    color: '#FAF500',
    dark: false,
    showLegend: true,
    legendOnly: true,
    order: 5.3,
  },
  {
    fieldPath: 'Other__c',
    label: 'その他',
    color: '#808080',
    dark: true,
    showLegend: false,
    order: 6,
  },
];
